<template>
    <div class="page" @click="$emit('click')">
        <slot></slot>
        <portal-target multiple name="popups"></portal-target>
        <div class="overlay" v-show="share.state.loader">
            <div class="loader-box">
                <div class="orbit-spinner">
                    <div class="orbit absolute border-primary border-b-3 left-0 top-0"></div>
                    <div class="orbit absolute border-primary border-r-3 right-0 top-0"></div>
                    <div class="orbit absolute border-primary border-t-3 left-0 bottom-0"></div>
                </div>
            </div>
        </div>
        <div style="z-index: 21" class="mask fixed inset-0 bg-overlay-500" v-if="share.state.currentAnnouncement">
            <div class="table-center">
                <m-announcement :title="share.state.currentAnnouncement.title" :body="share.state.currentAnnouncement.content"
                                @close="removeSelectedAnnouncement"></m-announcement>
            </div>
        </div>

        <transition name="slidedown">
            <div class="snackbar shadow-lg z-50" v-if="share.state.snack" :key="share.state.snack.key"
                 :class="share.state.snack.type">
                <div class="snackbar-content">
                    <div class="cell left">{{ share.state.snack.text }}</div>
                    <div class="cell right action font-bold" @click="dismiss">Dismiss</div>
                </div>
            </div>
        </transition>
        <m-dialog :heading="share.state.header" :modal="true" :show.sync="share.state.showConfirm"
                  @close="confirm(false)">
            <div class="w-full text-center">
                <div class="btn btn-primary" @click="confirm(true)">Yes</div>
                <div class="btn btn-error" @click="confirm(false)">No</div>
            </div>
        </m-dialog>
        <m-dialog v-if="share.state.validationErrors" heading="Validation errors" :modal="true"
                  :show.sync="share.state.showValidation">
            <p class="m-2">It seems your request is not valid. Please alter the data and resubmit.</p>
            <ul>
                <li class="pl-4 text-error-600" v-for="message in share.state.validationErrors">- {{ message }}</li>
            </ul>
            <template slot="footer">
                <div class="btn btn-primary" @click="share.state.showValidation = false">Ok</div>
            </template>
        </m-dialog>
        <transition name="slidedown" appear="appear">
            <div class="snackbar shadow-lg error z-50" v-if="share.state.showError">
                <div class="snackbar-content">
                    <div class="absolute right-0">
                        <div class="sprite-icons-bug"></div>
                    </div>
                    <div class="cell left">
                        <p class="font-bold">Dear {{ user }}</p>
                        <p>There seems to be an issue with your request. Our team has been notified. </p>
                        <p>We apologise for the inconvenience. </p>
                        <p>Please try this enquiry at a later stage.</p>
                    </div>
                    <div class="cell right action font-bold align-bottom" @click="share.hideError()">Dismiss</div>
                </div>
            </div>
        </transition>
        
        <div class="fixed mb-24 right-0 bottom-0 bg-red-600 m-4 rounded p-6 text-white z-50"
             v-if="share.state.upgrade && share.state.upgrade.show">
            <div class="sprite-icons-gears float-right"></div>
            <div class="text-2xl font-bold underline">Update Scheduled</div>
            <p class="text-white">A new version is available for your MarisIT experience.</p>
            <p>Please finish off with what you're busy with.</p>
            <p>Thank you for your patience.</p>
            <div class="btn btn-primary mt-4" @click="reload()">Refresh</div>
        </div>
    </div>
</template>

<script>
import Share from "../share.js";
import Annoucement from './announcement.vue'

export default {
    components: {
        'm-announcement': Annoucement
    },
    data() {
        return {
            share: Share,
            user: window.initial ? window.initial.user : 'user'
        }
    },
    methods: {
        reload() {
            window.location.reload()
        },
        removeSelectedAnnouncement() {
            this.share.closeAnnouncement()
        },
        dismiss() {
            // share.state.snack.dismiss
            Share.dismiss();
        },
        confirm(state) {
            this.share.confirmState(state)
        }
    }
};
</script>

<style lang="scss" scoped>

.orbit-spinner {
    height: 300px;
    width: 300px;
    border-radius: 50%;
    perspective: 800px;
}

.orbit-spinner .orbit {
    position: absolute;
    box-sizing: border-box;
    width: 100%;
    height: 100%;
    border-radius: 50%;
}

.orbit-spinner .orbit:nth-child(1) {
    animation: orbit-spinner-orbit-one-animation 1200ms linear infinite;
}

.orbit-spinner .orbit:nth-child(2) {
    animation: orbit-spinner-orbit-two-animation 1200ms linear infinite;
}

.orbit-spinner .orbit:nth-child(3) {
    animation: orbit-spinner-orbit-three-animation 1200ms linear infinite;
}

@keyframes orbit-spinner-orbit-one-animation {
    0% {
        transform: rotateX(35deg) rotateY(-45deg) rotateZ(0deg);
    }
    100% {
        transform: rotateX(35deg) rotateY(-45deg) rotateZ(360deg);
    }
}

@keyframes orbit-spinner-orbit-two-animation {
    0% {
        transform: rotateX(50deg) rotateY(10deg) rotateZ(0deg);
    }
    100% {
        transform: rotateX(50deg) rotateY(10deg) rotateZ(360deg);
    }
}

@keyframes orbit-spinner-orbit-three-animation {
    0% {
        transform: rotateX(35deg) rotateY(55deg) rotateZ(0deg);
    }
    100% {
        transform: rotateX(35deg) rotateY(55deg) rotateZ(360deg);
    }
}

.loader-box {
    z-index: 60;
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
}

.overlay {
    z-index: 61;
    position: fixed;
    top: 0px;
    left: 0px;
    right: 0px;
    bottom: 0px;
    background-color: rgba(100, 100, 100, 0.4);
}

$snackbar-opacity: 0.85;
.snackbar {
    position: fixed;
    right: 0px;
    bottom: 60px;
    background-color: #646465;
    border-radius: 16px;
    padding: 16px;
    color: #fff;
    margin: 16px;
    min-width: 240px;
    opacity: $snackbar-opacity;
}

.info {
    background-color: #646465;
}

.error {
    background-color: #ff6347;
}

.success {
    background-color: #48b04b;
}

.warning {
    background-color: #ff9901;
}

.snackbar-content {
    position: relative;
    display: table;
    width: 100%;
}

.cell {
    display: table-cell;

    &.left {
        text-align: left;
    }

    &.right {
        text-align: right;
    }
}

.action {
    font-size: 1.2em;
    text-transform: uppercase;
    cursor: pointer;
    color: #dfdfdf;
    padding-left: 12px;
}

.slidedown-enter {
    transition: all 0.9s ease;
    transform: translateY(-300px);
    opacity: 0;
}

.slidedown-enter-active {
    transition: all 0.9s ease;
}

.slidedown-enter-to {
    transform: translateY(0px);
    opacity: $snackbar-opacity;
}

.slidedown-leave {
    transform: translateY(0px);
    opacity: $snackbar-opacity;
}

.slidedown-leave-active {
    transition: 0.4s ease-in-out;
}

.slidedown-leave-to {
    transform: translateY(60px);
    opacity: 0;
}
</style>


